{
  "receive.heading": "Empfangen",
  "receive.description": "Diese Seite zeigt den Status, den Zyklus und die Anzahl der Container und Pakete im Empfangsprozess",
  "receive.filter.title": "Optionen",
  "receive.filter.cycle": "Zyklus",
  "receive.current_planned": "Aktuell geplant",
  "receive.current_actual": "Aktuell Angekommen Ist",
  "receive.other": "Sonstiges/Ungeplant Angekommen Ist",
  "CPT.": "CPT",
  "CPT.cpt": "CPT",
  "CPT.induct_by": "Einleiten von",
  "CPT.stow_by": "Verstauen",
  "package.cpt": "CPT",
  "receive.overall_status": "Gesamtstatus",
  "receive.packages": "Pakete",
  "receive.predicted_dispatch": "Voraussichtliche Versandmenge (LMCP)",
  "receive.container_planned_volume": "Container geplantes Volumen",
  "receive.current_cycle_planned": "Aktueller Zyklus geplant",
  "receive.current_cycle_actual": "Tatsaechlich angekommene Pakete fuer den Cycle",
  "receive.other_cycles": "Tatsaechlich angekommene Pakete fuer andere/ungeplante Cyclen",
  "receive.total": "Gesammte angekommene Paketen",
  "receive.current_status": "Aktueller Status",
  "receive.manifested": "In Ladungsverzeichnis eingetragen",
  "receive.manifested.unplanned": "Andere/ungeplante manifestierte Cyclen",
  "receive.in_transit": "Unterwegs",
  "receive.in_transit.unplanned": "Andere/ungeplante Pakete in Transit",
  "receive.arrived": "Angekommene Pakete",
  "receive.arrived.unplanned": "Andere/ungeplant angekommene Pakete",
  "receive.marked_for_reprocess": "Gekennzeichnet zur Neubearbeitung",
  "receive.marked_for_reprocess.unplanned": "Gekennzeichnet zur Neubearbeitung fuer einen anderen Cycle",
  "receive.inducted": "Eingeführt",
  "receive.stow_buffered": "Puffert verstauen",
  "receive.stowed": "Abgelegt",
  "receive.sidelined": "Herausgenommen",
  "receive.group_by": "Gruppieren nach",
  "linehaul.linehauls": "Ferntransporte",
  "linehaul.status": "Status",
  "linehaul.arrival": "Ankunft",
  "linehaul.details": "Details",
  "linehaul.vrid": "VRID",
  "linehaul.origin": "Herkunft",
  "linehaul.location": "Ort",
  "linehaul.planned": "Geplant",
  "linehaul.actual": "Ist",
  "linehaul.volume": "Volumen",
  "linehaul.FMC": "FMC",
  "linehaul.unloadSequence": "Entladesequenz",
  "linehaul.inyard": "Im Hof",
  "linehaul.arrived": "Angekommen",
  "linehaul.incoming": "Eingehend",
  "linehaul_detail.receive": "Empfangen",
  "linehaul_detail.linehaul_details": "Ferntransportdetails",
  "linehaul_detail.linehaul": "Ferntransport ",
  "linehaul_detail.from": "Von",
  "linehaul_detail.departed": "Abgefahren",
  "linehaul_detail.arrived": "Angekommen",
  "linehaul_detail.options": "Optionen",
  "linehaul_detail.id": "Nummer",
  "linehaul_detail.type": "Typ",
  "linehaul_detail.pending_induct": "Ausstehende Einführung ",
  "linehaul_detail.total": "Gesamt ",
  "linehaul_filter.packagesize": "Paketgröße",
  "linehaul_filter.ead": "Haltestelle EAD",
  "linehaul_filter.cycle": "Zyklus",
  "linehaul_filter.cluster": "Cluster",
  "linehaul_filter.otherattributes": "Weitere Merkmale",
  "linehaul_filter.clear_all": "Alles löschen",
  "induct.heading": "Einführen",
  "induct.description": "Diese Seite zeigt den Status, den Zyklus und die Anzahl der Behälter und Pakete im Induct-Prozess",
  "induct.induct": "Einführen",
  "induct.induct_area": "Einführungsbereiche",
  "induct.active_associate": "Aktive Mitarbeiter",
  "induct.induct_rate": "Einführungsrate",
  "induct.total_inducted": "Gesamt eingeführt",
  "induct.container": "Container",
  "induct.container_id": "Nummer",
  "induct.type": "Typ",
  "induct.pending_induct": "Ausstehende Einführung ",
  "induct.total": " Gesamt",
  "induct.aslInductArea": "ASL Induct Bereich",
  "induct.max_induct_rate": "Max Induct rate",
  "induct.station_percentage": "% des Stationsvolumens",
  "induct.successful_percentage": "% erfolgreich",
  "induct.kickout": "Kickout",
  "induct.noread": "NoRead",
  "induct.timeout": "Timeout",
  "induct.failed_verification": "Failed Verification",
  "induct.sidelined": "Sidelined",
  "induct.cycle": "Zyklus",
  "associate.heading": "Mitarbeiter einführen",
  "associate.description": "Auf dieser Seite werden die Leistungsdaten und den aktuellen Arbeitsstandort von Induct Associates angezeigt",
  "associate.option": "Optionen",
  "associate.active": "Aktiv",
  "associate.associates": "Mitarbeiter",
  "associate.associate": "Mitarbeiter",
  "associate.pph": "PPH",
  "associate.hours": "Stunden",
  "associate.total_packages": "Pakete gesamt",
  "associate.location": "Ort",
  "associate.inactive_period": "Inaktive Periode",
  "package.package_summary": "Paketübersicht",
  "package.tracking_id": "Verfolgungsnummer",
  "package.last_scan_date_time": "Letzter Scan",
  "package.minutes_in_state": "Minuten in Zustand",
  "package.package_state": "Zustand",
  "package.package_reason": "Grund",
  "package.location": "Ort",
  "package.cycle": "Zyklus",
  "package.sort_zone": "Sortierbereich",
  "package.cluster": "Cluster",
  "package.EAD": "Haltestelle EAD",
  "package.size": "Größe",
  "package.station_code": "Ziel",
  "package.package_list": "Paketliste",
  "induct.error": "Es ist ein Fehler aufgetreten",
  "tooltip.max_induct_rate": "Maximum expected induct rate for the ASL machine.",
  "tooltip.induct_rate": "Average number of packages inducted per hour.",
  "tooltip.total_inducted": "Total number of packages inducted in the current shift.",
  "tooltip.stowbuffered_cycle": "Sendungen, die sich derzeit in diesem Paketzustand befinden und während dieses Zyklus erfolgreich gepuffert wurden",
  "tooltip.station_percentage": "Percentage of total station volume that was inducted using the ASL machine.",
  "tooltip.successful_percentage": "Percentage of packages that were successfully scanned by the ASL machine.",
  "tooltip.kickout": "Number of packages that were kicked-out during ASL induct.",
  "tooltip.noread": "Number of ASL processed packages where a valid barcode was not read by the entry camera.",
  "tooltip.timeout": "Number of ASL processed package scans which did not receive induct response within the SLA.",
  "tooltip.failed_verification": "Number of ASL processed packages which were not verified by the exit camera.",
  "tooltip.non_conveyable_description": "NC: Packages that exceed 42'' in a single dimension. \n FCLM might have different dimension criteria for NC",
  "induct_management.induct_setup": "Induct Setup",
  "induct_management.select_cycle": "Select Cycle",
  "induct_management.current_sort_cycle": "Current Sort Cycle",
  "induct_management.current_cycle_state": "Current Cycle State",
  "induct_management.current_force_induct_status": "Current Force Induct Status",
  "induct_management.enable_force_induct": "Enable Force Induct",
  "induct_management.sort_cycle": "Sort Cycle",
  "induct_management.force_induct_sort_cycle": "Force induct all received packages in current sort cycle",
  "induct_management.start_sort_cycle": "Start Induct",
  "induct_management.container_plan_failure" : "There is an error fetching Container Plan. Please try again Later",
  "induct_management.mapped_cycles_failure" : "There is an error fetching Active Cycles. Please try again Later",
  "induct_management.set_node_operational_failure" : "There is an error saving the Induct Cycle. Please Try again Later",
  "induct_management.get_node_operational_failure" : "There is an error getting the current Sort Cycle Information. Please Try again Later",
  "induct_management.non_mco_station" : "This page is not enabled yet for your station. If your station supports multi cycle operations, stay tuned for more updates :-)",
  "induct_management.bad_request" : "Please select correct cycle from the dropdown",
  "induct_management.set_node_induct_process_details_success" : "Induct Cycle has been started successfully",
  "induct_management.no_active_container_plans_available" : "There are no active container plans configured for this station, Please try again later",
  "induct_management.pick_started_for_the_current_cycle" : "Pick has been started for the current cycle, so induct is blocked on ",
  "induct_management.start_induct" : ". Please change to correct cycle and start the induct process.",
  "common.data_last_updated": "Daten wurden zuletzt aktualisiert",
  "inductmanagement.heading": "Scan-Zyklus-Management einführen",
  "inductmanagement.description": "Auf dieser Seite können Sie die Einstellungen für den Induktionszyklus ändern",
  "inductmanagement.manage_cycle": "Zyklen verwalten",
  "inductmanagement.force_induct": "Scan einführen erzwingen",
  "inductmanagement.active_until": "Aktiv bis",
  "inductmanagement.noCycles": "Keine Zyklen verfügbar",
  "inductmanagement.disableCycle": "Zyklus deaktivieren",
  "inductmanagement.enableCycle": "Zyklus aktivieren",
  "inductmanagement.enterCycle": "Zyklus betreten...",
  "inductmanagement.enterStationCode": "Station Code eingeben...",
  "inductmanagement.noStations": "Keine Stationen verfügbar",
  "inductmanagement.selectStatus": "Status auswählen...",
  "inductmanagement.enableForceInduct": "Force Induct-Scan aktivieren",
  "inductmanagement.disableForceInduct": "Force Induct-Scan deaktivieren",
  "inductmanagement.activateSortToRouteError": "Ein weiterer Sort_TO_ROUTE-Typ Zyklus kann nicht aktiviert werden. {cycle} ist bereits aktiv.",
  "inductmanagement.activateCycleError": "Beim Aktivieren des Zyklus ist ein Fehler aufgetreten: {cycle}",
  "inductmanagement.deactivateCycleError": "Beim Deaktivieren des Zyklus ist ein Fehler aufgetreten: {cycle}",
  "inductmanagement.unselectedWarning": "Bitte wählen Sie einen Knoten aus und wechseln Sie, bevor Sie auf Aktivieren",
  "inductmanagement.setForceError": "Beim Aktualisieren des Force Induct-Scans für den Zyklus ist ein Fehler aufgetreten: {cycleName}",
  "inductmanagement.submit": "Einreichen",
  "inductconfig.noActiveLanes": "Alle Bahnen sind entweder inaktiv oder Hold-Bahnen, keine Bahnen für Paletten oder Wagen übrig.",
  "inductconfig.noCartLanes": "Alle Bahnen sind entweder inaktiv, Hold- oder Palettenbahnen. Keine Bahnen für Wagen übrig.",
  "inductconfig.noBeltsConfigured": "Keine Induktionsbänder konfiguriert. Bitte fügen Sie mindestens ein Band hinzu.",
  "inductconfig.holdLaneWarning": "Keine Hold-Bahnen konfiguriert. Container können während dieses Zyklus nicht gehalten werden. Möchten Sie fortfahren?",
  "inductconfig.singleBeltWarning": "Nur ein aktives Band konfiguriert. Wenn dieses Band ausfällt, können keine Pakete eingeleitet werden. Möchten Sie fortfahren?",
  "inductconfig.inactiveHoldOverlap": "Inaktive Bahn(en) {lanes} können nicht gleichzeitig in Hold-Bahnen sein.",
  "inductconfig.inactivePalletOverlap": "Inaktive Bahn(en) {lanes} können nicht gleichzeitig in Palettenbahnen sein.",
  "inductconfig.palletLanes": "Palettenbahnen",
  "inductconfig.priorityLaneCount": "Anzahl Prioritätsbahnen",
  "inductconfig.priorityLaneCountHint": "Anzahl der Prioritätsbahnen eingeben (z.B. 25)",
  "inductconfig.beltNoContainerTypes": "Ein oder mehrere Bänder haben keine Containertypen ausgewählt. Wählen Sie mindestens einen Containertyp für jedes Band aus.",
  "inductconfig.beltNoCubeTypes": "Ein oder mehrere Bänder haben keine Würfeltypen ausgewählt. Wählen Sie mindestens einen Würfeltyp für jedes Band aus.",
  "inductconfig.noActiveBelts": "Keine aktiven Induktionsbänder konfiguriert. Mindestens ein Band muss aktiv sein, um Pakete zu verarbeiten.",
  "inductconfig.containerTypeNotCovered": "Ein oder mehrere Containertypen sind keinem aktiven Band zugeordnet. Alle Containertypen müssen von mindestens einem aktiven Band abgedeckt werden.",
  "inductconfig.cubeTypeNotCovered": "Ein oder mehrere Würfeltypen sind keinem aktiven Band zugeordnet. Alle Würfeltypen müssen von mindestens einem aktiven Band abgedeckt werden.",
  "inductconfig.invalidLaneEntered": "Ungültige Bahn eingegeben. Bitte geben Sie eine gültige Bahnkennung ein.",
  "inductconfig.selectCycleBeforeUpload": "Bitte wählen Sie einen Zyklus vor dem Hochladen aus.",
  "inductconfig.invalidCycleInCsv": "Ungültiger oder fehlender Zyklus in der CSV. Bitte geben Sie einen gültigen Zyklus ein."
}
